import React from 'react';
import { useTranslation } from 'react-i18next';
import { useOptionalSoundNotificationsContext } from '../../contexts/SoundNotificationsContext';

export default function SoundButton({ coin }) {
  const { t } = useTranslation();
  const ctx = useOptionalSoundNotificationsContext();
  const isMuted = ctx ? ctx.isMuted : false;
  const handleClick = () => {
    if (ctx && typeof ctx.toggleMute === 'function') ctx.toggleMute();
  };

  const tooltip = t(
    'chartPage.soundTooltip',
    'Sound alerts are sent whenever a significant whale trade or liquidation occurs, so you never miss a market move.\nBTC & ETH: alerts trigger on trades above $10M and liquidations above $1M.\nAltcoins: alerts trigger on trades above $1M and liquidations above $1M.'
  );

  return (
    <button
      type="button"
      className={`ct-sound-btn ${isMuted ? 'muted' : 'unmuted'}`}
      aria-label={tooltip}
      aria-pressed={!isMuted}
      data-tooltip={tooltip}
      onClick={handleClick}
      disabled={!ctx}
    >
      {isMuted ? (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/>
          <line x1="22" y1="9" x2="16" y2="15"/>
          <line x1="16" y1="9" x2="22" y2="15"/>
        </svg>
      ) : (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/>
          <path d="M19.07 4.93a10 10 0 0 1 0 14.14"/>
          <path d="M15.54 8.46a5 5 0 0 1 0 7.07"/>
        </svg>
      )}
      <span className="ct-sound-tooltip" role="tooltip">{tooltip}</span>
    </button>
  );
}
